import React from 'react';
import { Grid } from '@mui/material';
import { RootineFooter } from '../components';
import { CustomIcon } from '../atoms';
export const Icons = (): JSX.Element => {
  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={4}
        rowSpacing={2}
        sx={{
          paddingLeft: { xs: 2, md: 10, lg: 20, xl: 35 },
          paddingRight: { xs: 2, md: 10, lg: 20, xl: 35 },
          marginTop: { xs: 10, md: 10 },
        }}
      >
        <Grid item xs={12}>
          <CustomIcon debug={1} name="test" hex="black" />
          <RootineFooter />
        </Grid>
      </Grid>
    </>
  );
};
